// Octane Quiz: Render star ratings for product results
(function() {
  function createStarRating(rating, count) {
    // Round to nearest 0.5
    const roundedRating = Math.round(rating * 2) / 2;
    const fullStars = Math.floor(roundedRating);
    const hasHalfStar = roundedRating % 1 !== 0;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    // Generate unique ID for gradients
    const uniqueId = `octane_star_${count}_${Math.random().toString(36).slice(2, 11)}`;

    // SVG for filled star (100% filled)
    const filledStarSVG = `<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="oct-quiz-review-stars__star">
      <defs>
        <linearGradient id="${uniqueId}_filled">
          <stop offset="100%" stop-color="rgba(0,0,0,1)"></stop>
          <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
        </linearGradient>
      </defs>
      <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(0,0,0,1)" fill="url('#${uniqueId}_filled')"></path>
    </svg>`;

    // SVG for half star (51% filled)
    const halfStarSVG = `<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="oct-quiz-review-stars__star">
      <defs>
        <linearGradient id="${uniqueId}_half">
          <stop offset="51%" stop-color="rgba(0,0,0,1)"></stop>
          <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
        </linearGradient>
      </defs>
      <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(0,0,0,1)" fill="url('#${uniqueId}_half')"></path>
    </svg>`;

    // SVG for empty star (0% filled)
    const emptyStarSVG = `<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="oct-quiz-review-stars__star">
      <defs>
        <linearGradient id="${uniqueId}_empty">
          <stop offset="0%" stop-color="rgba(0,0,0,1)"></stop>
          <stop stop-opacity="1" offset="0%" stop-color="#FFFFFF"></stop>
        </linearGradient>
      </defs>
      <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(0,0,0,1)" fill="url('#${uniqueId}_empty')"></path>
    </svg>`;

    let starsHTML = '';

    // Add filled stars
    for (let i = 0; i < fullStars; i++) {
      starsHTML += filledStarSVG;
    }

    // Add half star if needed
    if (hasHalfStar) {
      starsHTML += halfStarSVG;
    }

    // Add empty stars
    for (let i = 0; i < emptyStars; i++) {
      starsHTML += emptyStarSVG;
    }

    return `<div class="oct-quiz-review-stars">
      <div class="oct-quiz-review-stars__stars">${starsHTML}</div>
      <span class="oct-quiz-review-stars__count">(${count})</span>
    </div>`;
  }

  function processProductCards() {
    const productCards = document.querySelectorAll('.oct-quiz-result-item__copy-wrapper');

    productCards.forEach(card => {
      // Skip if already processed
      if (card.querySelector('.oct-quiz-review-stars')) {
        return;
      }

      // Find the wrapper div containing the review data
      const wrapperDiv = card.querySelector('div:first-of-type');
      if (!wrapperDiv) return;

      // Get all child divs
      const childDivs = Array.from(wrapperDiv.children);
      if (childDivs.length < 2) return;

      // Last two divs contain rating and count
      const ratingDiv = childDivs[childDivs.length - 2];
      const countDiv = childDivs[childDivs.length - 1];

      if (!ratingDiv || !countDiv) return;

      // Extract values
      const rating = parseFloat(ratingDiv.textContent.trim());
      const count = parseInt(countDiv.textContent.trim());

      // Validate the data (make sure they're numbers)
      if (isNaN(rating) || isNaN(count)) return;

      // Create and insert star rating HTML
      const starsHTML = createStarRating(rating, count);

      // Insert before the description (at the bottom of the copy section)
      const descriptionElement = card.querySelector('.oct-quiz-result-item__description');
      if (descriptionElement) {
        descriptionElement.insertAdjacentHTML('beforebegin', starsHTML);
      }
    });
  }

  function showSectionsAfterQuiz() {
    // Find all .image-hero and .rich-text elements that come after the quiz section
    const quizSection = document.querySelector('[new-quiz] #octane-quiz-wrapper')?.closest('.shopify-section');
    if (!quizSection) return;

    let nextSection = quizSection.nextElementSibling;
    while (nextSection) {
      if (nextSection.classList.contains('shopify-section')) {
        // Show .image-hero and .rich-text elements within this section
        const imageHero = nextSection.querySelector('.image-hero');
        const richText = nextSection.querySelector('.rich-text');

        if (imageHero) imageHero.style.display = 'block';
        if (richText) richText.style.display = 'block';
      }
      nextSection = nextSection.nextElementSibling;
    }
  }

  function hideSectionsAfterQuiz() {
    // Find all .image-hero and .rich-text elements that come after the quiz section
    const quizSection = document.querySelector('[new-quiz] #octane-quiz-wrapper')?.closest('.shopify-section');
    if (!quizSection) return;

    let nextSection = quizSection.nextElementSibling;
    while (nextSection) {
      if (nextSection.classList.contains('shopify-section')) {
        // Hide .image-hero and .rich-text elements within this section
        const imageHero = nextSection.querySelector('.image-hero');
        const richText = nextSection.querySelector('.rich-text');

        if (imageHero) imageHero.style.display = 'none';
        if (richText) richText.style.display = 'none';
      }
      nextSection = nextSection.nextElementSibling;
    }
  }

  function initResultsPageHandler() {
    // Try to process immediately if results are already loaded
    if (document.querySelector('.oct-quiz-products')) {
      processProductCards();
      showSectionsAfterQuiz();
    }

    // Watch for results page to load
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          const resultsContainer = document.querySelector('.oct-quiz-products');
          if (resultsContainer) {
            // Give Octane a moment to fully render the products
            setTimeout(() => {
              processProductCards();
              showSectionsAfterQuiz();
            }, 100);
          }
        }
      }
    });

    // Observe the quiz wrapper for changes
    const quizWrapper = document.querySelector('[new-quiz] #octane-quiz-wrapper');
    if (quizWrapper) {
      observer.observe(quizWrapper, {
        childList: true,
        subtree: true
      });
    }

    // Listen to questionAnswered event as a backup trigger
    document.addEventListener('octane.quiz.questionAnswered', function() {
      setTimeout(() => {
        if (document.querySelector('.oct-quiz-products')) {
          processProductCards();
          showSectionsAfterQuiz();
        }
      }, 200);
    });

    // Listen to questionLoaded event to hide sections when navigating back to questions
    document.addEventListener('octane.quiz.questionLoaded', function() {
      // If we're on a question page (not results), hide the sections
      if (!document.querySelector('.oct-quiz-products')) {
        hideSectionsAfterQuiz();
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initResultsPageHandler);
  } else {
    initResultsPageHandler();
  }
})();

